var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.5 6.25a2.73 2.73 0 0 1-.5 0V17.8a2.52 2.52 0 0 1 1 0V6.2a2.73 2.73 0 0 1-.5.05zM6.2 3a2.73 2.73 0 0 1 0 .5 2.73 2.73 0 0 1 0 .5h11.6a2.734 2.734 0 0 1-.05-.5c.001-.168.018-.335.05-.5H6.2zm0 17c.067.33.067.67 0 1h11.6a2.52 2.52 0 0 1 0-1H6.2zM3 6.2v11.6c.165-.032.332-.049.5-.05.168.001.335.018.5.05V6.2a2.73 2.73 0 0 1-.5 0 2.73 2.73 0 0 1-.5 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 20.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0zm17 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0zm-17-17a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0zm17 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.9bccaaa637c68a66e46ca3ff5186c9ab.svg";
export { ForwardRef as ReactComponent };